<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计数据</el-breadcrumb-item>
      <el-breadcrumb-item>总计统计数据</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
        <el-form-item label="App类型">
            <el-select placeholder="请选择App类型"  v-model="userSearchData.app_id">
                <el-option
                  v-for="item in appids"
                  :key="item.app_id"
                  :label="item.name"
                  :value="item.app_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="渠道类型">
            <el-select placeholder="请选择渠道类型"  v-model="userSearchData.channel_id">
                <el-option
                  v-for="item in channelids"
                  :key="item.channel_id"
                  :label="item.name"
                  :value="item.channel_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="是否分渠道展示" v-if="isChannelUnselected()">
          <el-select v-model="userSearchData.open_type" style="width: 150px">
            <el-option label="合并展示" :value="0"/>
            <el-option label="分渠道展示" :value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item label="招商经理">
            <el-select placeholder="请选择招商经理"  v-model="userSearchData.system_user_id">
                <el-option
                  v-for="item in system_user_ids"
                  :key="item.system_user_id"
                  :label="item.system_user_id"
                  :value="item.system_user_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="数据方案">
            <el-select placeholder="请选择数据方案类型"  v-model="userSearchData.group_id">
                <el-option
                  v-for="item in groups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="注册日期" style="width: 320px">
          <el-date-picker
            v-model="userSearchData.regtime"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="查询时间" prop="date_type">
          <el-select
            v-model="userSearchData.date_type"
            clearable
            style="width: 150px"
          >
          <el-option label="不选择" value="-1"/>
            <el-option label="日总计" value="0"/>
            <el-option label="月总计" value="1"/>
            <el-option label="全部总计" value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item label="开始月份" v-if="showMonthRange">
          <el-date-picker
            v-model="userSearchData.create_month_time"
            style="width: 220px"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择开始月份"
          />
        </el-form-item>
        <el-form-item label="结束月份" v-if="showMonthRange">
          <el-date-picker
            v-model="userSearchData.update_month_time"
            style="width: 220px"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择结束月份"
          />
        </el-form-item>
        <el-form-item label="选择日期" v-if="showDateRange">
          <el-date-picker
            v-model="userSearchData.time"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()"
            >统计搜索</el-button>
          <el-button v-if="showUpdateAD" type="primary" icon="el-icon-search" size="mini" @click="updateAdverPrice()"
            >编辑广告费</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%" ref="table">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width" 
          :fixed="column.fixed || null"
          >
        </el-table-column>
        <el-table-column prop="address" label="操作" width="160" fixed="right" v-if="isShowUpdatePrice">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="edit(scope.row)"
              >编辑广告费</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100, 200, 300, 500]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>

    <!-- 编辑版本弹框 -->
    <el-dialog  v-loading="editpageloading" title="编辑广告费信息" :visible.sync="editVisible" width="50%">
      <el-form
        :model="editruleForm"
        ref="editruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="广告费" prop="total_adver_price">
          <el-input v-model="editruleForm.total_adver_price"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('editruleForm')"
            >提交修改</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑弹框 -->
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getcurrentTime } from "@/utils/public";
import { isString } from '../../utils/util';
export default {
  data() {
    return {
      showUpdateAD: true,
      isShowUpdatePrice: false,
      pageloading: false,
      editpageloading: false,
      showDateRange: false,
      showMonthRange: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        name: "",
        app_id: 0,
        channel_id: "",
        open_type: 0,
        system_user_id: 0,
        create_month_time: "",
        update_month_time: "",
        regtime: "",
        time: "",
        type: "",
        date_type: "",
        group_id: 0
      },
      // 添加版本信息数据
      addruleForm: {
        name: "",
        type_desc: "",
        type_value: -1,
        tb_name: "",
        tb_item_name: "",
        is_qujian: -1,
        s_value: "",
        e_value: "",
        sort: 0
      },
      // 修改版本信息数据
      editruleForm: {
        id: "",
        total_adver_price: ""
      },
      appids: [
        {
          app_id: "",
          name: "",
        }
      ],
      channelids: [
        {
          channel_id: "",
          channel_name: "",
        }
      ],
      system_user_ids: [
        {
          system_user_id: "",
        }
      ],
      groups: [
        {
          id: "",
          name: "",
        }
      ],
      tableData: [],
      columns: [],
      tableColumns: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchAllAppidsData();
    this.searchChannelIdsData();
    this.searchSysteUserIdsData();
    this.searchAllGourpData();
  },

  watch: {
    'userSearchData.date_type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.userSearchData.date_type == 0) { //日
          this.showDateRange = true;
          this.showMonthRange = false;
        } else if (this.userSearchData.date_type == 1) { //月
          this.showDateRange = false;
          this.showMonthRange = true;
        } else {
          this.showDateRange = false;
          this.showMonthRange = false;
        }
      }
    },
    'userSearchData.channel_id': function() {
      if (!this.isChannelUnselected()) {
        this.userSearchData.open_type = 0;
      }
    }
  },

  methods: {
    isChannelUnselected() {
      return this.userSearchData.channel_id === "" ||
        this.userSearchData.channel_id === 0 ||
        this.userSearchData.channel_id === "0" ||
        this.userSearchData.channel_id == null;
    },
    updateIsNull(value) {
       return `${(value * 100.00).toFixed(2)}%`;
    },
    toPercentage(value) {
       return `${(value * 100.00).toFixed(2)}%`;
    },
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    getAppName(item) {
      var string = ``;
      if (item != null && this.appids != null) {
        for(var i=0; i<this.appids.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.app_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }
      return string;
    },
    async searchAllAppidsData() {
      this.$axios
      .post("/3699BIApi/AppId/SearchAllData", {})
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["app_id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.appids = resultData;
        }
      });
    },
    getChannelName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.channelids.length; i++) {
          var itemObject = this.channelids[i];
          if (itemObject.channel_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }      
      return string;
    },
    async searchChannelIdsData() {
      this.$axios
      .post("/3699BIApi/ChannelId/SearchAllData", {})
      .then(res => {
        if (res.data.code != 200) {
          this.$message.error(`查询失败:${res.data.msg}`);
          return;
        }
        var array = res.data.list;
        var resultData = [];
        var fob = new Object();
        fob["channel_id"] = "";
        fob["name"] = "不选择";
        resultData.push(fob);
        for(var i = 0; i < array.length; i++) {
          let itemObject = array[i];
          var ob = new Object();
          for(var k in itemObject) {
              ob[k] = itemObject[k];
          }
          resultData.push(ob);
        }
        this.channelids = resultData;
      });
    },
    async searchSysteUserIdsData() {
      this.$axios
      .post("/3699BIApi/ChannelApkReview/AllSearchData", {})
      .then(res => {
        if (res.data.code != 200) {
          this.$message.error(`查询失败:${res.data.msg}`);
          return;
        }
        var array = res.data.list;
        var resultData = [];
        var fob = new Object();
        fob["system_user_id"] = "不选择";
        resultData.push(fob);
        for(var i = 0; i < array.length; i++) {
          let itemObject = array[i];
          var ob = new Object();
          for(var k in itemObject) {
              ob[k] = itemObject[k];
          }
          resultData.push(ob);
        }
        this.system_user_ids = resultData;
      });
    },
    async searchAllGourpData() {
      this.$axios
      .post("/3699BIApi/AdminDataSumShowGroupConfig/SearchData",{
          type: Number.parseInt(0),
          currentPage: 1,
          pageSize: 100
      })
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.groups = resultData;
        }
      });
    },
    updateAdverPrice() {
      if (this.isShowUpdatePrice == true) {
        this.isShowUpdatePrice = false;
      } else {
        this.isShowUpdatePrice = true;
      }
    },
    // 添加用户弹框
    addversion() {
      this.addVisible = true;
    },
    // 添加用户按钮
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let time = getcurrentTime();
          this.addruleForm.create_time = time;
          console.log(this.addruleForm);
          //添加版本
          this.addVersionData(this.addruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置添加用户
    addresetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击编辑行内容并更改数据
    edit(data) {
      this.editVisible = true;
      for(var k in data) {
        this.editruleForm[k] = data[k];
      }
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editVisible = false;
          this.updateDataInfo(this.editruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 编辑version
    async updateDataInfo(requestObject) {
      this.$axios
        .post("/3699BIApi/DataSum/UpdateAdverPrice",{
            id: Number.parseInt(requestObject.id),
            total_adver_price: Number.parseFloat(requestObject.total_adver_price)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          if (res.data.code == "200") {
            this.$message.success("编辑成功");
            this.searchDataInfo();
          } else {
            this.$message.error("编辑失败");
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.updateCurrpageData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.updateCurrpageData();
    },
    async searchData(requestObject) {
      if (Number.parseInt(requestObject.group_id) <= 0) {
        this.$message.error("数据方案不能为空!");
        return;
      }
      this.searchAppData(requestObject);
    },
    searchAppData(requestObject) {
      this.$axios
      .post("/3699BIApi/DataSum/SearchData",{
          app_id: Number.parseInt(requestObject.app_id),
          channel_id: this.isChannelUnselected() ? 0 : Number.parseInt(requestObject.channel_id),
          system_user_id: Number.parseInt(requestObject.system_user_id),
          reg_start_time: requestObject.regtime[0],
          reg_end_time: requestObject.regtime[1],
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          create_month_time: requestObject.create_month_time,
          update_month_time: requestObject.update_month_time,
          type: Number.parseInt(requestObject.date_type),
          open_type: Number.parseInt(requestObject.open_type),
          group_id: Number.parseInt(requestObject.group_id),
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.columns = res.data.columns;
          this.tableColumns = res.data.columns;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.currentPage = 1;
      this.searchData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = (this.currentPage-1) * this.pageSize;
      var endi = i + this.pageSize;
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
  }
};
</script>

<style lang="sass" scoped></style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         



// WEBPACK FOOTER //
// src/views/Data/DataSum.vue